import React, { useEffect, Fragment, useState } from 'react';
import getDescricaoRecurso from '../Recursos';
import '../css/TabelaDadosStyle.css';
import { useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import useAuth from "../context/useAuth";
import getPrioridadeLinha from '../js/Prioridades';
import getOrdenacao from '../js/Ordenacao';
import moment from 'moment';
import { NavItem } from 'react-bootstrap';
import ignorarIDGeral from '../js/IgnorarID';
function

    TabelaDados(props) {


    const [MostrarTodasAsLinhas, setMostrarTodasAsLinhas] = useState({});
    const toggleMostrarTodasAsLinhas = (recursoNome) => {
        setMostrarTodasAsLinhas((prevMostrarTodasAsLinhas) => ({
            ...prevMostrarTodasAsLinhas,
            [recursoNome]: !prevMostrarTodasAsLinhas[recursoNome],
        }));
    };

    let location = useLocation();



    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    const { logout } = useAuth();
    let listaRecursos = [];

    const RecursosMonitorados = ['MONITOR_DISCO_BANCO', 'MONITOR_DISCO_WINDOWS', 'ATUALIZACAO_BANCO', 'ATUALIZACAO_BANCO2',
        'ATUALIZACAO_BANCO_AURELIUS', 'ATUALIZACAO_PRECO', 'ATUALIZACAO_BANCO_DROP', 'Diretório da pasta data fora do padrão', 'MONITOR_MEMORIA', 'MONITOR_BLOCOX_ESTOQUE'];

    props.recursos.map((gia) => {

        let dirMySQL = "";

        let dataAtual = new Date();


        if (dirMySQL.startsWith("C:\\")) {
            let DirC = {
                recurso: "Diretório da pasta data fora do padrão",
                status: "ERRO",
                mensagem: "Diretório pasta data armazenado no disco C:\\ ",
                dataUltimaExecucao: dataAtual
            }
            const index = gia.recursos.findIndex(object => object._id === DirC._id && object.recurso === DirC.recurso);
            if (index === -1) {
                gia.recursos.push(DirC);
            }
        }


        gia.recursos.map((rec) => {
            
            if (location.pathname === "/dashboard") {
                if (!RecursosMonitorados.includes(rec.recurso)) {
                    return null;
                }
            }


            var rc = listaRecursos.find(busca => busca.Nome === rec.recurso);
            if (!rc) {
                rc = {
                    Nome: rec.recurso,
                    Rodando: 0,
                    Erro: 0,
                    Desativado: 0,
                    gias: []
                };
                listaRecursos.push(rc);
            }
            if (!ignorarIDGeral.includes(gia._id)) {
                if (rec.status === "RODANDO") {
                    rc.Rodando += 1;
                }
                else if (rec.status === "ERRO") {
                    rc.Erro += 1;
                    if (rec.dataUltimaExecucao === "" || rec.dataUltimaExecucao === "2010-01-01 00:00:00") {
                        rc.gias.push({ id: gia._id, mensagem: rec.mensagem, data: "Nunca executado", valorAtual: rec.valorAtual, valorReferencia: rec.valorReferencia, regimeTributario: gia.regimeTributario });
                    } else {
                        rc.gias.push({ id: gia._id, mensagem: rec.mensagem, data: moment(rec.dataUltimaExecucao).format('DD/MM/YYYY HH:mm'), valorAtual: rec.valorAtual, valorReferencia: rec.valorReferencia, regimeTributario: gia.regimeTributario });
                    };

                }
                else if (rec.status === "DESATIVADO") {
                    rc.Desativado += 1;
                }
                return null;
            } return null;

        });

        return null;

    })

    return (
        <div className="pagina">
            <div><NavBar /></div>
            <div className="containerTabela ">

                {listaRecursos.map((recurso, i) => {
                    const mostrarTodasAsLinhas = MostrarTodasAsLinhas[recurso.Nome] || false;
                    const mostrarLinhas = mostrarTodasAsLinhas ? recurso.gias.length : Math.min(recurso.gias.length, 5);
                    if (recurso.Erro > 0)
                        return (

                            <table key={i} className="min-w-full divide-gray-200 mb-3 "
                                style={{ backgroundColor: '#1E1E2E', borderRadius: '10px', border: 'solid', borderSpacing: '0', overflow: 'hidden' }}>
                                <thead style={{ backgroundColor: '#1E1E2E', fontFamily: 'Raleway' }}>
                                    <tr style={{ backgroundColor: '#1E1E2E' }}>
                                        <th th colSpan="22">

                                            <span className='text-2xl text-gray-100 inline-flex text-g px-2 py-2.5' style={{ fontFamily: 'Roboto' }} >{getDescricaoRecurso(recurso.Nome)}
                                                <span style={{ fontFamily: 'Roboto' }} className="inline-flex items-center justify-center w-9 h-9 ml-2 text-2xl font-semibold text-gray-50 bg-gray-500 rounded-full">
                                                    {recurso.Erro}
                                                </span>

                                            </span>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody style={{ backgroundColor: '#27293D' }} className="text-white">
                                    {recurso.gias
                                        .sort((linhaA, linhaB) => getOrdenacao(recurso.Nome, linhaA, linhaB))
                                        .slice(0, mostrarLinhas)
                                        .map((linha, index) => {
                                            const estiloLinha = getPrioridadeLinha(recurso.Nome, linha.valorAtual, linha.valorReferencia, linha.regimeTributario);
                                            return (
                                                <tr key={index}>
                                                    <td className={`px-6 py-2 w-0/4 text-left ${index === 0 ? 'rounded-tl-lg' : ''}`}>{linha.id}</td>
                                                    <td> </td>
                                                    <Fragment key={index}>
                                                        <td className="w-1/4 px-6 text-justify">   {linha.data}   </td>
                                                    </Fragment>
                                                    <td className={`w-2/3 text-left ${index === 0 ? 'rounded-tr-lg' : ''}`} style={estiloLinha}>{linha.mensagem}</td>
                                                    <td> </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                                {recurso.gias.length > 5 && (
                                    <tfoot style={{ backgroundColor: '#27293D' }} >
                                        <tr>
                                            <td colSpan="5">
                                                <button className='text-xs pl-4 text-gray-50 ' onClick={() => toggleMostrarTodasAsLinhas(recurso.Nome)}>
                                                    {mostrarTodasAsLinhas ? 'Ver Menos' : 'Ver Mais...'}
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>

                                )}
                            </table>


                        )
                    return null;
                })

                }

                <div><button className="glass-button" onClick={logout}>Sair </button>
                </div>

            </div>

        </div>
    );
}

export default TabelaDados;